import { Volume2, VolumeX } from "lucide-react";

export function AudioControl({ muted, onToggle }: { muted: boolean; onToggle: () => void }) {
  return (
    <button
      className="audio-control"
      type="button"
      onClick={onToggle}
      aria-pressed={!muted}
      aria-label={muted ? "Turn chamber sound on" : "Turn chamber sound off"}
      title={muted ? "Sound off — turn on" : "Sound on — turn off"}
    >
      {muted ? <VolumeX aria-hidden="true" /> : <Volume2 aria-hidden="true" />}
      <span>{muted ? "Sound off" : "Sound on"}</span>
    </button>
  );
}
